<div
  class="min-h-screen grid grid-cols-1 md:grid-cols-2 p-0 md:p-12 bg-cover bg-no-repeat bg-center bg-none md:bg-[url('/Background.svg')]"
>
  <!-- Left: Signup Steps -->
  <div class="bg-white rounded-0 md:rounded-3xl shadow-lg p-10 lg:p-10 md:p-5 m-0 mr-0">
    <div class="flex items-center gap-2 mb-6">
      <img src="/logo.svg" alt="plandag logo" class="h-[33px] w-auto" />

      <span class="text-[27px] leading-[27px] font-semibold tracking-tight text-[#00165A]">
        plandag
      </span>
    </div>
    <p-stepper [value]="activeStep" class="w-full">
      <p-step-list class="text-[14px]">
        <p-step [value]="1" class="text-[14px]">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <span
              class="rounded-full border-2 w-6 h-6 text-[12px] inline-flex items-center justify-center"
              [ngClass]="{
                'custom-green text-primary-contrast border-[#00B87A]': value < activeStep,
                'shadow-lg border-[#FFFFFF]': value === activeStep,
                'border-surface text-muted-color': value > activeStep,
              }"
            >
              @if (value < activeStep) {
                ✔
              } @else if (value === activeStep) {
                <span
                  class="rounded-full w-3 h-3 text-[6px] inline-flex items-center justify-center custom-green"
                ></span>
              } @else {
                {{ '' }}
              }
            </span>
            <span
              class="text-[15px] font-bold break-words whitespace-normal"
              [ngClass]="{
                'text-[15px] font-bold text-[#00165A]': value === activeStep || value < activeStep,
                'text-muted-color': value > activeStep,
              }"
            >
              {{ i18n.t('personalDetails') }}</span
            >
          </ng-template>
        </p-step>

        <p-step [value]="2" class="text-[14px]">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <span
              class="rounded-full border-2 w-6 h-6 text-[12px] inline-flex items-center justify-center"
              [ngClass]="{
                'custom-green text-primary-contrast border-[#00B87A]': value < activeStep,
                'shadow-lg border-[#FFFFFF]': value === activeStep,
                'border-surface text-muted-color': value > activeStep,
              }"
            >
              @if (value < activeStep) {
                ✔
              } @else if (value === activeStep) {
                <span
                  class="rounded-full w-3 h-3 text-[6px] inline-flex items-center justify-center custom-green"
                ></span>
              } @else {
                {{ '' }}
              }
            </span>
            <span
              [ngClass]="{
                'text-[15px] font-bold text-[#00165A]': value === activeStep || value < activeStep,
                'text-muted-color': value > activeStep,
              }"
              class="break-words whitespace-normal"
              >{{ i18n.t('businessDetails') }}</span
            >
          </ng-template>
        </p-step>

        <!-- <p-step [value]="3" class="text-[14px]">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <span class="rounded-full border-2 w-6 h-6 text-[12px] inline-flex items-center justify-center" [ngClass]="{
                'custom-green text-primary-contrast border-[#00B87A]': value < activeStep,
                'shadow-lg border-[#FFFFFF]': value === activeStep,
                'border-surface text-muted-color': value > activeStep
              }">
              @if (value < activeStep) { ✔ } @else if(value===activeStep){ <span
                class="rounded-full w-3 h-3 text-[6px] inline-flex items-center justify-center custom-green"></span>
            }@else{ {{ '' }} }
            </span>
            <span class="break-words whitespace-normal" [ngClass]="{
                'text-[15px] font-bold text-[#00165A]': value === activeStep || value < activeStep,
                'text-muted-color': value > activeStep
              }">Your team</span>
          </ng-template>
        </p-step> -->
      </p-step-list>

      <p-step-panels class="!py-0 [&_.p-steppanels]:!gap-0">
        <!-- Step 1 -->
        <p-step-panel [value]="1">
          <ng-template #content let-activateCallback="activateCallback">
            <div class="p-[4px]">
              <app-create-account
                (onSubmit)="goToStep(2); activateCallback(2)"
              ></app-create-account>
            </div>
          </ng-template>
        </p-step-panel>

        <!-- Step 2 -->
        <p-step-panel [value]="2">
          <ng-template #content let-activateCallback="activateCallback">
            <div class="p-[4px]">
              <app-business-details
                (onBack)="goToStep(1); activateCallback(1)"
                (onSubmit)="goToStep(3); activateCallback(3)"
              ></app-business-details>
            </div>
          </ng-template>
        </p-step-panel>

        <!-- Step 3 -->
        <p-step-panel [value]="3">
          <ng-template #content let-activateCallback="activateCallback">
            <div class="p-[4px]">
              <app-create-team></app-create-team>
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-panels>
    </p-stepper>
  </div>

  <!-- Right: Promo Panel -->

  <div class="hidden md:flex items-center justify-center">
    <!-- Background Image -->
    <!-- <img src="/Background.svg" class="absolute inset-0 w-full h-full object-cover opacity-30" /> -->

    <div class="relative z-10 max-w-lg text-center space-y-8">
      <!-- Budget Card -->

      <div class="mt-4 flex items-center flex-col justify-center">
        <!-- Semi-Gauge -->

        <p-carousel
          [value]="[1]"
          [numVisible]="0"
          [numScroll]="0"
          [circular]="false"
          [showNavigators]="false"
          [showIndicators]="false"
          class="mt-4 flex items-center justify-center"
        >
          <ng-template let-product #item>
            <div class="m-2 p-4">
              <div class="mb-2">
                @if (activeStep == 1) {
                  <img src="personal-details.svg" class="w-full rounded-border" />
                } @else if (activeStep == 2) {
                  <img src="org-detail.svg" class="w-full rounded-border" />
                } @else if (activeStep == 3) {
                  <img src="team-icon.svg" class="w-full rounded-border" />
                }
              </div>
            </div>
          </ng-template>
        </p-carousel>
        @if (activeStep == 1) {
          <h3 class="text-2xl font-semibold mb-4 text-[#00165A]">{{ i18n.t('startYour30DaysTrial') }}</h3>
          <ul class="space-y-2 text-lg text-slate-700">
            <li class="flex items-center justify-start gap-2">
              <span class="text-[#00165A] font-bold">✔</span> {{ i18n.t('noCreditCardRequired') }}
            </li>
            <li class="flex items-center justify-start gap-2">
              <span class="text-[#00165A] font-bold">✔</span> {{ i18n.t('exploreWiserFeaturesAtNoCost') }}
            </li>
          </ul>
        } @else {
          <p class="text-slate-700">
            Lorem lpsum is simply dummy text of the printing and typesetting industry. Lorem lpsum
            has been the industry's standard dummy text
          </p>
        }
      </div>

      <!-- Dots -->
    </div>
  </div>
</div>
